import { Component, EventEmitter, Input, Output } from "@angular/core";
import { Document, IDocument } from "src/app/interfaces";

@Component({
    selector: "circ-document-list",
    templateUrl: "./list.component.html",
    styleUrls: ["./list.component.scss"],
    standalone: false
})
export class ListComponent {
  @Input()
  public documents: Document[] = [];
  @Output()
  public documentDelete = new EventEmitter<IDocument>();
  @Output()
  public documentOpen = new EventEmitter<IDocument>();
  @Output()
  public documentDownload = new EventEmitter<IDocument>();

  public onDeleteDocument(document: IDocument): void {
    this.documentDelete.emit(document);
  }
  public onOpenDocument(document: IDocument): void {
    this.documentOpen.emit(document);
  }
  public onDownloadDocument(document: IDocument): void {
    this.documentDownload.emit(document);
  }
}
